import { DeviceTypeFilterParams, getDeviceType, getDeviceTypes } from '../../api/deviceTypes';
import { DeviceType } from '../../interfaces/api/deviceType';

export async function fetchDeviceTypes(params: DeviceTypeFilterParams): Promise<DeviceType[]> {
	try {
		return await getDeviceTypes(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchDeviceType(
	id: number,
	params: DeviceTypeFilterParams
): Promise<DeviceType> {
	try {
		return await getDeviceType(id, params);
	} catch (error) {
		throw error;
	}
}
